import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './KatilimUcreti.css';

function KatilimUcreti() {
  return (
    <div className="ucret-page">
      <Navbar />

      <header className="page-hero">
        <div className="container">
          <h2>KATILIM ÜCRETİ</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi</p>
        </div>
      </header>

      <main className="content-container">

        <section className="fee-table-section">
          <h3>KATILIM ÜCRETİ (TL)</h3>

          <div className="table-responsive">
            <table className="fee-table">
              <thead>
                <tr>
                  <th>Katılımcı Türü</th>
                  <th>Erken Kayıt </th>
                  <th>Geç Kayıt (5 Mayıs'tan sonra)</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    Yüksek Lisans ve Doktora Öğrencileri
                    <br />
                    (herhangi bir kurumda kadrolu olmayanlar)
                  </td>
                  <td>2500</td>
                  <td>3000</td>
                </tr>

                <tr>
                  <td>
                    Bağımsız Araştırmacılar
                    <br />
                    (Herhangi bir kuruma bağlı olmayanlar)
                  </td>
                  <td>2500</td>
                  <td>3000</td>
                </tr>

                

                <tr>
                  <td>Tüm Öğretim Elemanları</td>
                  <td>3500</td>
                  <td>4250</td>
                </tr>

                <tr>
                  <td>Misafir Katılımcı</td>
                  <td>3000</td>
                  <td>3750</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <div className="google-form-note">
  * Kayıt işlemleri Google Forms üzerinden yapılacaktır. 
  Form bağlantısı başvuru sayfasında paylaşılacaktır.
</div>


        {/* ÖDEME BİLGİLERİ */}
        <section className="bank-details-card">
          <h3>Ödeme</h3>

          <p><strong>Elif Durdu</strong></p>
          <p className="iban-text">TR 04 0013 4000 0164 8198 4000 01</p>

          <div className="payment-note">
            <p>
              Ödeme yapılırken <strong>34. Ulusal Yönetim ve Organizasyon Kongresi Katılım Ücreti</strong>
              olarak belirtilmesi ve katılımcı detayının verilmesi, dekontun bir örneğinin
              kongre mail adresine gönderilmesi rica olunur.
            </p>
          </div>
        </section>

        {/* KONAKLAMA VE ULAŞIM */}
        <section className="bank-details-card">
          <h3>KONAKLAMA VE ULAŞIM</h3>

          <p><strong>ERETNA OTEL</strong></p>
          <p>Paşabey Atatürk Bulvarı No:36 Sivas / Merkez</p>

          <p>
            Otel rezervasyon ve alternatif konaklama önerileri için aşağıdaki telefon
            numarasından iletişime geçebilirsiniz.
          </p>

          <p>
            <strong>Elif Durdu GSM:</strong> 0545 360 70 79 (WhatsApp üzerinden)
          </p>
        </section>

      </main>

      <Footer />
    </div>
  );
}

export default KatilimUcreti;
